module.exports = __webpack_public_path__ + "static/img/amg-3.74d2cf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/amg-3.jpg
// module id = JTIN
// module chunks = 1